import { Injectable } from "@angular/core";
import { Http ,Response,Headers, ResponseContentType, RequestOptions,ResponseOptions, Request } from "@angular/http";
import { Observable } from "rxjs";
import { global } from '../../models/global';

@Injectable({
    providedIn: 'root'
})
export class BulkUploadService {
    ROOT_URL: string = "";
    constructor(private http: Http) {
        let g: global = new global();
        this.ROOT_URL = g.getApiUrl();
    } 

    DownloadBulkJobCancellationExcel(): Observable<any> {
        let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('mcmt_token'), 'UserID': localStorage.getItem('mcmt_userId') });
        let requestoptions: RequestOptions = new RequestOptions({
            method: 'GET',
            url: this.ROOT_URL + "/api/BulkUpload/DownloadBulkJobCancelExcel",
            headers: headers,
            responseType: ResponseContentType.Blob,
        })
         return this.http.request(new Request(requestoptions))
         .map((res: Response) => {
            var blob = new Blob([res.blob()], { type: 'xlsx' })
            return blob;
        });
    }
 
    uploadBulkJobCancellation(fileList: any): Observable<any> {
        let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('mcmt_token'), 'UserID': localStorage.getItem('mcmt_userId') });
        let requestoptions: RequestOptions = new RequestOptions({
            method: 'POST',
            url: this.ROOT_URL + "/api/BulkUpload/UploadBulkJobCancellationDocument",
            headers: headers,
            body: fileList,
            responseType: ResponseContentType.Json
        })
        return this.http.request(new Request(requestoptions))  
        .map(response => <any>(<Response>response).json());
    }
}
